export const identity = <T>(arg: T) => arg;

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
export const voidF = <T>(...args: any[]): void => {};

export const callIf =
  (fn: Function | undefined) =>
  <T>(...args: T[]) =>
    fn && fn(...args);
